<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_surtit" epub:type="title"><span><img alt="Illustration" class="imagelarge_intext" id="box_1e" src="images/box.jpg"/><br/>
<img alt="Illustration" class="imagelarge_intext" id="back_6" src="images/back.jpg"/></span></h1>
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Getting the Most Out of <i>The Twelve Disciples</i></a></div>
<div class="table" id="tableau-001">
<div class="table-align">
<table border="" style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:7px;">
<col style="width:15%;padding:7px;"/>
<col style="width:85%;padding:7px;"/>
</colgroup>
<tbody>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><a href="#/chap1"><span class="mev2">ONE</span></a></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><a href="#/chap1">Andrew: Bringing Others to Jesus<br/><span class="mev5">JOHN 1:35–42</span></a></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap2" title="Link target outside of Sample"><span class="mev2">TWO</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">Simon Peter: Defending (and Rebuking) the Savior<br/><span class="mev5">MARK 1:16–20; 8:27–38</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap3" title="Link target outside of Sample"><span class="mev2">THREE</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">Matthew: Drawing in the Outcast<br/><span class="mev5">Matthew 9:9–13</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap4" title="Link target outside of Sample"><span class="mev2">FOUR</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">James: Hating Our Enemies<br/><span class="mev5">Luke 9:51–56; Acts 12:1–2</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap5" title="Link target outside of Sample"><span class="mev2">FIVE</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">Philip: Learning to Trust<br/><span class="mev5">John 6:1–13</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap6" title="Link target outside of Sample"><span class="mev2">SIX</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">John: Seeking to Be the Greatest<br/><span class="mev5">Matthew 20:20–28</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap7" title="Link target outside of Sample"><span class="mev2">SEVEN</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">Thomas: Leaving Doubt Behind<br/><span class="mev5">John 20:19–29</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap8" title="Link target outside of Sample"><span class="mev2">EIGHT</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample">Nathanael: Developing Spiritual Insight<br/><span class="mev5">John 1:43–51</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap9" title="Link target outside of Sample"><span class="mev2">NINE</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample">Judas Iscariot: Turning Away<br/><span class="mev5">Matthew 26:14–30, 47–50; 27:1–10</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap10" title="Link target outside of Sample"><span class="mev2">TEN</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample">Three Others: Faithful to the End<br/><span class="mev5">Luke 18:18–30</span></span></p></td>
</tr>
</tbody></table></div></div>
<div class="SOM_appen"><span href="#/chap11" title="Link target outside of Sample">Leader’s Notes</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">What Should We Study Next?</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?ce436484